import { Storyline } from '../types/index.js';

interface Props {
  storyline: Storyline;
  onStart: () => void;
}

export function StorylineIntro({ storyline, onStart }: Props) {
  return (
    <div className="storyline-intro">
      <div className="intro-badge">CASE FILE</div>
      <h1 className="intro-network">Operation: {storyline.networkName}</h1>
      <p className="intro-narrative">{storyline.narrative}</p>

      <div className="intro-profile-preview">
        <h2>Your Subject</h2>
        <p className="intro-subject-name">{storyline.customerProfile.name}</p>
        <p className="intro-subject-meta">
          {storyline.customerProfile.profession} · {storyline.customerProfile.location}
        </p>
      </div>

      <div className="intro-instructions">
        <h3>Your Mission</h3>
        <p>
          Review <strong>10 transactions</strong> and classify each as{' '}
          <span className="tag-legitimate">Legitimate</span>,{' '}
          <span className="tag-suspicious">Suspicious</span>, or{' '}
          <span className="tag-fraudulent">Fraudulent</span>.
        </p>
        <p>Your decisions are compared against an AI fraud detection model. See how your instincts stack up.</p>
      </div>

      <button className="btn-primary btn-large intro-start" onClick={onStart}>
        Begin Investigation
      </button>
    </div>
  );
}
